var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-header',{class:['admin-header']},[_c('a-row',{attrs:{"type":"flex","justify":"space-between"}},[_c('a-col',{attrs:{"span":3}},[_c('a-input-search')],1),_vm._v(" "),_c('a-col',{attrs:{"span":4}},[_c('span',[_c('a-icon',{attrs:{"type":"user"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }